// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2D9kp","range":"MonthRangeSwitch_range__ft7KN","disabled":"MonthRangeSwitch_disabled__3s4Qb"};